// Copyright (c) 2022 Celadon Development LLC, All rights reserved.
// Author Alexander Mikholap <alexander.miholap@celadon.ae>
import GlobalStyles from '../../../../config/styles';

const styles = () => ({
  container: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  errorText: {
    maxWidth: '80%',
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
    fontSize: GlobalStyles.fonts.FONT_SIZE_SMALL,
    color: GlobalStyles.color.COLOR_REJECT,
    textAlign: 'center',
    marginBottom: 10,
  },
});

export default styles;
